(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MusicalArrangementTypeIbqDialogController', MusicalArrangementTypeIbqDialogController);

    MusicalArrangementTypeIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MusicalArrangementType'];

    function MusicalArrangementTypeIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, MusicalArrangementType) {
        var vm = this;

        vm.musicalArrangementType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.musicalArrangementType.id !== null) {
                MusicalArrangementType.update(vm.musicalArrangementType, onSaveSuccess, onSaveError);
            } else {
                MusicalArrangementType.save(vm.musicalArrangementType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:musicalArrangementTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
